<div class="d-flex align-items-center justify-content-between drag-handle fmd-header" cdkDragHandle cdkDrag cdkDragRootElement=".cdk-overlay-pane"
ngxResizable
[ngxResizableTargetElement]="'.mat-mdc-dialog-surface'"
[ngxResizableEventClass]="'modal-file-resizing'"
(cdkDragEnded)="onDragEnded($event)"
(cdkDragStarted)="onDragStarted($event)"
>
    @if(fileEdit$()?.name){
        <h4 class="f-s-16 f-w-600 flex-fill" mat-dialog-title>{{ fileEdit$()?.name ?? 'File'}}</h4>
        <button mat-icon-button (click)="closeEditFile()">
            <i-tabler name="xbox-x"></i-tabler>
        </button>
        <button mat-icon-button (click)="pinDialog()"  [matTooltip]="'filemanager.manager.toggle_pinned' | translate" matTooltipPosition="above">
            @if(pinned$()){
                <i-tabler name="pinned-filled"></i-tabler>
            }@else{
                <i-tabler name="pin"></i-tabler>
            }
        </button>
    }@else{
        <h4 class="f-s-16 f-w-600 flex-fill" mat-dialog-title>{{ dataModule?.title ?? ('filemanager.manager.title' | translate) }}</h4>
    <button mat-icon-button mat-dialog-close>
        <i-tabler name="xbox-x"></i-tabler>
    </button>
    <button mat-icon-button (click)="pinDialog()">
        @if(pinned$()){
            <i-tabler name="pinned-filled"></i-tabler>
        }@else{
            <i-tabler name="pin"></i-tabler>
        }
    </button>
    }
    
</div>  
<mat-dialog-content class="mat-typography p-0 fmd-container"> 
    @if(fileEdit$()?.uuid){
        <div class="editor-wrapper">
            @if(fileType$() == 'file'){

                <app-modals-send-file [directData]="fileEdit$()" [modal]="false"></app-modals-send-file>
            }@else{
                <app-modals-cut-pdf [directData]="fileEdit$()" [modal]="false"></app-modals-cut-pdf>
            }
        </div>
    }@else{
        <nxe-content [showSwitcher]="true" [showSendFile]="true"></nxe-content>
    }
</mat-dialog-content>


